import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router'
import ReactPaginate from 'react-paginate'
// import airfreightratsServices from '../../Services/airfreightratesServices'
import { ChangeStatus } from '../../Components'
import Loader from '../../Components/Loader'

import { MdVisibility, MdDeleteForever, MdEdit } from "react-icons/md"

export const SalesAgentList = () => {
    // eslint-disable-next-line
    const [retailerList, setRetailerList] = useState([1, 2, 3, 4, 5, 6])
    // eslint-disable-next-line
    const [pagination, setPagination] = useState({ page: 1, limit: 10 })
    const [currentPage, setCurrentPage] = useState(1)
    const [isModalOpen, setIsModalOpen] = useState(false)
    const [deleteModalOpen, setDeleteModalOpen] = useState(false)
    const [loader, setLoader] = useState(true)
    // const [countryValue, setCountryValue] = useState('')

    const history = useHistory()
    // const imgRef = useRef()

    useEffect(() => {
        setLoader(false)
        // getRetailerList()
    }, [currentPage])

    // const getRetailerList = (countryId = countryValue ? countryValue.label : '') => {
    //     let param = { ...pag ination, page: currentPage }
    //     if (countryId) {
    //         param['search'] = countryId
    //         param['page'] = 1
    //     }
    //     airfreightratsServices.getAirfreightrates(param).then(res => {
    //         if (res.status) {
    //             setLoader(false)
    //             setRetailerList(res.data)
    //             setPagination(res.pagination)
    //         } else {
    //             setLoader(false)
    //         }
    //     })
    // }
    const onModalSubmit = () => {
        // let postData = {
        //     airfreightrats_id: isModalOpen._id,
        //     airfreight_status: isModalOpen.airfreight_status === 'ACTIVE' ? 'INACTIVE' : 'ACTIVE'
        // }
        // airfreightratsServices.updateAirfreightratestatus(postData).then(res => {
        //     if (res.status) {
        setIsModalOpen(false)
        // getRetailerList()
        //     }
        // })
    }

    const onPageChangeEvent = (e) => {
        setLoader(true)
        setCurrentPage(e.selected + 1)
    }

    // const onSelectCountry = (e,) => {
    //     setCountryValue(e)
    //     getRetailerList(e.value)
    // }

    return (

        <div className="row">
            <div className="col-lg-12">
                <div className="card">
                    <div className="card-body">
                        <div className="d-flex justify-content-between mb-3">
                            <div>
                                <input
                                    type="text"
                                    className={'form-control'}
                                    placeholder="Search..."
                                />
                            </div>
                            <button className="btn btn-primary w-sm waves-effect waves-light mx-3"
                                onClick={() => history.push('/add-sales-agent')}
                            >Add Sales Agent
                            </button>
                        </div>
                        <div className="table-responsive">
                            <table className="table table-centered table-nowrap mb-0">
                                <thead className="table-light">
                                    <tr>
                                        <th>S no.</th>
                                        <th>Agent Name</th>
                                        <th>Contact No.</th>
                                        <th>Email</th>
                                        <th>Action</th>


                                    </tr>
                                </thead>
                                <tbody>
                                    {retailerList.length > 0 && retailerList.map((item, key) => (
                                        <tr key={key}>
                                            <td className="text-body fw-bold">{((pagination.page - 1) * pagination.limit) + (key + 1)}</td>
                                            <td>Demo</td>
                                            <td> orum@gmail.com </td>
                                            <td>9575961109</td>
                                            {/* <td>
                                                <span
                                                    className={"badge rounded-pill font-size-12 pointer" + (item.airfreight_status === 'ACTIVE' ? ' bg-success' : ' bg-soft-danger')}
                                                    onClick={() => setIsModalOpen(item)}
                                                >{item.airfreight_status}</span>
                                            </td> */}
                                            <td>
                                                {/* Button trigger modal */}
                                                {/* <MdDelete color="#fed203" size="30px"/> */}
                                                <MdEdit
                                                    className="pointer"
                                                    onClick={() => history.push('/edit-sales-agent?id=' + item._id, item)}
                                                    color="#0323fe"
                                                    size="25px"
                                                />
                                                <MdDeleteForever
                                                    // className="btn btn-primary btn-sm btn-rounded waves-effect waves-light"
                                                    className="pointer"
                                                    color="red"
                                                    size="25px"
                                                    onClick={() => setDeleteModalOpen(item)}

                                                />
                                                <MdVisibility
                                                    className="pointer"
                                                    onClick={() => history.push('/sales-agent-details')}
                                                    color="#0323fe"
                                                    size="25px"
                                                />
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            {retailerList.length <= 0 && !loader &&
                                <div className="text-center w-100 bg-warning my-5">
                                    <h6 className="py-2"> list not available </h6>
                                </div>
                            }
                        </div>
                    </div>
                    {retailerList.length > 0 && pagination.totalRecord > pagination.limit &&
                        <ReactPaginate
                            previousLabel={<img src="assets/images/prev.svg" height={15} alt='prev'/>}
                            forcePage={currentPage - 1}
                            nextLabel={<img src="assets/images/next.svg" height={15} alt='next' />}
                            breakLabel={'...'}
                            breakClassName={'break-me'}
                            pageCount={Math.ceil(pagination.totalRecord / pagination.limit)}
                            marginPagesDisplayed={2}
                            pageRangeDisplayed={3}
                            onPageChange={(e) => onPageChangeEvent(e)}
                            containerClassName={'pagination'}
                            activeClassName={'active'}
                        />
                    }
                    <Loader isShow={loader} />
                </div>
                {Boolean(isModalOpen) &&
                    <ChangeStatus
                        isOpen={Boolean(isModalOpen)}
                        title='Update Status'
                        message={`Are you sure want to ${isModalOpen.airfreight_status === 'ACTIVE' ? 'Inactive' : 'Active'} status ?`}
                        onSubmitEvent={() => onModalSubmit()}
                        handleClose={() => setIsModalOpen(false)}
                    />
                }

                {Boolean(deleteModalOpen) &&
                    <ChangeStatus
                        isOpen={Boolean(deleteModalOpen)}
                        title='Delete'
                        message={`Are you sure want to delete?`}
                        onSubmitEvent={() => setDeleteModalOpen(false)}
                        handleClose={() => setDeleteModalOpen(false)}
                    />
                }
            </div>
        </div >
    )
}
